export default "__VITE_ASSET__BGPYk5Fv__"